import { TemplateGroup } from "../models/basic/template";
import { AbstractService } from "./abstract-service";
import { URLS } from "./app-urls";
import Api from "./api-config";
import { trackPromise } from "react-promise-tracker";

export class NpiTemplateGroupService extends AbstractService<TemplateGroup> {
    constructor() {
        super(URLS.TEMPLATE_GROUP);
    }

    async reorder(itemId: number, itemMoveId: number) {
        return await trackPromise(Api.patch(`${this.path}${itemId}/reorder/`, {
            item_move: `${this.path}${itemMoveId}/`,
        }));
    }
}